import React, { useState } from "react";
import { useUploadHelper } from "./useUploadHelper";
import { CreateProductType } from "../../types";
import { message } from "antd";

interface ImageUploadProps {
  payload: { images: string[] };
  setActive: React.Dispatch<React.SetStateAction<number>>;
  setPayload: React.Dispatch<React.SetStateAction<CreateProductType>>;
}

const NewUploadImageForm: React.FC<ImageUploadProps> = ({
  payload,
  setActive,
  setPayload,
}) => {
  // const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const { mutateAsync } = useUploadHelper({ payload, setPayload });

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.files) return;
    const filesArray = Array.from(event.target.files);

    if (payload.images.length + filesArray.length > 5) {
      message.error("You can only upload up to 5 images");
      return;
    }

    // setSelectedFiles((prev) => [...prev, ...filesArray]);

    for (const file of filesArray) {
      try {
        await mutateAsync(file);
      } catch (error) {
        console.error("Upload error:", error);
      }
    }
  };

  const handleRemoveImage = (index: number) => {
    const updatedImages = payload.images.filter((_, i) => i !== index);
    setPayload((prev) => ({ ...prev, images: updatedImages }));
  };

  return (
    <div className="mx-auto w-[500px] border-[1px] border-[#eeeeee] rounded-[10px] mt-[20px]">
      <div className="p-[20px] font-medium border-b-[1px] border-[#eeeeee]">
        Upload Product Image(s)
      </div>
      <div className="p-[20px]">
        <div>
          <div className="py-[20px] mb-[30px] bg-[#f0f0f0] rounded-md">
            <label className="cursor-pointer">
              <FileIcon />
              <p className="text-center mt-[18px]">
                Drag and drop or{" "}
                <span className="text-orange">browse file</span> to upload
              </p>
              <div className="text-center text-[#a5a5a5]">
                Max file size: 3000 by 3000 px, 20MB
              </div>
              <input
                type="file"
                id="upload"
                multiple
                accept="image/*"
                hidden
                onChange={handleFileChange}
                disabled={payload.images.length >= 5}
              />
            </label>
          </div>

          <div className="grid grid-cols-3 gap-4 pb-2">
            {payload.images.map((image, index) => (
              <div key={index} className="relative">
                <img
                  src={image}
                  alt={`Uploaded ${index}`}
                  className="w-full h-32 object-cover border-[1px] border-[#ddd] rounded-md p-2"
                />
                <button
                  onClick={() => handleRemoveImage(index)}
                  className="absolute top-1 right-1 bg-[#000000a8] text-white p-1 rounded-full text-xs"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </button>
              </div>
            ))}
          </div>
          {/* {JSON.stringify(payload?.images)} */}

          {payload.images.length >= 5 && (
            <p className="text-red-500 pb-2">Maximum of 5 images reached.</p>
          )}

          <button
            className="text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300 bg-brown opacity-50"
            onClick={() => setActive(2)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewUploadImageForm;

const FileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-12 mx-auto text-[#9d9d9d]"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    />
  </svg>
);
